import { render } from "./EditOrganizationDialog.vue?vue&type=template&id=0fe8e2c2"
import script from "./EditOrganizationDialog.vue?vue&type=script&lang=js"
export * from "./EditOrganizationDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__